import loadBlogList from "@iewcasia/Store/Handlers/Blog/LoadBlogList";
import { CustomState } from "@iewcasia/Store/Reducers";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    description = "description",

    displayDescription = "Page description",
}

interface OwnProps extends PageProps {
    fields: {
        [fields.description]: string;
    };
}

const mapStateToProps = (customState: CustomState) => {
    const location = getLocation(customState);
    return {
        location,
    };
};

const mapDispatchToProps = {
    loadBlogList,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const BlogLandingPage = ({ id, location: { search }, loadBlogList }: Props) => {
    React.useEffect(() => {
        loadBlogList({ search, isLandingPage: true, parameters: {}, isFirstLoad: true });
    }, []);

    return (
        <MobiusPage>
            <Zone
                contentId={id as never}
                zoneName={"Content" as never}
                requireRows={true as never}
                fixed={true as never}
            />
        </MobiusPage>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(BlogLandingPage) as any) as any,
    definition: {
        displayName: "Blog Landing",
        pageType: "Content",
        allowedChildren: ["BlogCategoryPage" as any],
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        fieldDefinitions: [
            {
                name: fields.description,
                displayName: fields.displayDescription,
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: false,
                collapsedToolbarButtons: {
                    moreText: {
                        buttons: ["paragraphFormat", "bold", "italic", "html"],
                        buttonsVisible: 4,
                    },
                },
            },
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
